// Service for the Attendance Dashboard "Mi equipo" — "Resumen del mes" "Horas extras"
// card (ASIS-5409 / REXASIS-008).
// GET /attendance/my-team/monthly-summary/overtime-summary?cutoffCompanyId=1&monthlyCutId=1 —
// both query params are required: the company and monthly cutoff selected in the
// "Resumen del mes" filters panel (ASIS-5414).

import { apiClient, API_CONFIG } from '@/api/core';
import type { ApiResponse } from '@/api/shared';
import { buildQueryString } from '@/api/shared';

import type {
  LC_GetMyTeamMonthlyOvertimeSummaryOut,
  GetMyTeamMonthlyOvertimeSummaryParams,
  MyTeamMonthlyOvertimeSummary,
} from '../types/myTeamMonthlyOvertimeSummary.types';
import { mapMyTeamMonthlyOvertimeSummary } from '../mappers/myTeamMonthlyOvertimeSummary.mapper';


export class MyTeamMonthlyOvertimeSummaryService {
  async getSummary(
    params: GetMyTeamMonthlyOvertimeSummaryParams,
    signal?: AbortSignal,
  ): Promise<ApiResponse<MyTeamMonthlyOvertimeSummary>> {
    const query = buildQueryString({
      cutoffCompanyId: params.cutoffCompanyId,
      monthlyCutId: params.monthlyCutId,
    });
    const { ATTENDANCE_MY_TEAM_MONTHLY_SUMMARY_OVERTIME_SUMMARY } = API_CONFIG.ENDPOINTS;
    const endpoint = `${ATTENDANCE_MY_TEAM_MONTHLY_SUMMARY_OVERTIME_SUMMARY}${query}`;
    const response = await apiClient.get<LC_GetMyTeamMonthlyOvertimeSummaryOut>(
      endpoint, { signal },
    );

    if (!response.success || !response.data) {
      return { ...response, data: null };
    }

    return { ...response, data: mapMyTeamMonthlyOvertimeSummary(response.data) };
  }
}

export const myTeamMonthlyOvertimeSummaryService = new MyTeamMonthlyOvertimeSummaryService();
